import moment from 'moment'

export const formatEpochTimestamp = (epochTime: number, format = 'MMMM Do, YYYY'): string => {
  /*
   * Unix timestamps have 10 digits and are stored as seconds
   * If there are more digits we can assume the timestamp is milliseconds
   */
  const divisor = epochTime.toString().length > 10 ? 1000 : 1
  return moment.unix(Number(epochTime / divisor)).format(format)
}
